import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const DropdownHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
  width: 100%;
  border-radius: 7px;
  background: ${COLORS.white};

  @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}) {
    padding: 0 8px;
  }
`

export const SearchInputWrapper = styled.div`
  flex: 1;
  width: 80%;
`

export const SearchInput = styled.input`
  display: inline-block;
  width: 100%;
  outline: none;
  cursor: text;
  min-height: 20px;
  padding-inline-start: 8px;
  text-align: left;
  border: none;
  background: transparent;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;

  &:focus {
    outline: none;
  }
`
